<!--
 * @description: 官网首页
 * @Author: wxy
 * @Date: 2020-02-11 11:24:27
 -->
<template>
  <div class="dashboard-container">
    <head-room ref="headroom" @clickDownload="clickDownload"></head-room>
    <dashboard-banner></dashboard-banner>
    <div class="content">
      <feature-introduction></feature-introduction>
      <function-introduction></function-introduction>
      <successful-case></successful-case>
      <application-download ref="applicationDownload"></application-download>
    </div>
    <footer>
      Copyright©2021 紫光云技术有限公司 津 ICP 备 19004759号-1津公网安备 12019202000336号
    </footer>
  </div>
</template>

<script>
import headRoom from './components/headRoom'
import dashboardBanner from './components/dashboardBanner'
import featureIntroduction from './components/featureIntroduction'
import functionIntroduction from './components/functionIntroduction'
import successfulCase from './components/successfulCase'
import applicationDownload from './components/applicationDownload'
export default {
  name: 'dashboard',
  components: {
    headRoom,
    dashboardBanner,
    featureIntroduction,
    functionIntroduction,
    successfulCase,
    applicationDownload
  },
  data() {
    return {}
  },
  created() {
    window.addEventListener('scroll', this.handleHeaderShow)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleHeaderShow)
  },
  methods: {
    clickDownload() {
      this.$refs.applicationDownload.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    handleHeaderShow() {
      let scrollTop = document.documentElement.scrollTop
      if (scrollTop > 486) {
        this.$refs.headroom.show()
      } else {
        this.$refs.headroom.hide()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .dashboard-container {
    min-width: 1200px;
    background-image: url('../../assets/img/dashboard/background-color.png');
    background-repeat: repeat-x;
    background-size: 5px 810px;
    background-color: #f6fbfd;
    .content > div {
      position: relative;
      width: 1000px;
      margin: 0 auto;
      margin-bottom: 50px;
    }
    .content > div:nth-last-child(1) {
      margin-bottom: 0px;
    }
    footer {
      min-height: 75px;
      color: #fff;
      font-size: 12px;
      text-align: center;
      background: #1c1f37;
      word-break: break-all;
      padding: 25px 15px;
      line-height: 25px;
    }
  }
  @media (max-width: 770px) {
    .dashboard-container {
      width: 100%;
      min-width: auto;
      overflow: hidden;
      .content > div {
        width: 90%;
      }
    }
  }
</style>
